import { z } from 'zod';

// A date as an AI answer carries one: an ISO-8601 string, the text 'null', a
// blank, or something that is not a date at all. Anything unusable becomes
// null rather than an error — an answer is offered to a nurse to correct, not
// rejected.
const toAiDate = (value: unknown) => {
  if (
    value === 'null' ||
    value === '' ||
    value === null ||
    value === undefined
  ) {
    return null;
  }

  const date = new Date(value as string);
  return isNaN(date.getTime()) ? null : date;
};

// `.default(null)` also covers a date the answer left out entirely: zod 4.5
// stopped running `preprocess` for keys absent from an object, so without it a
// missing date is dropped from the answer instead of read as null.
export const AiDateSchema = z
  .preprocess(toAiDate, z.date().nullish())
  .default(null)
  .meta({ type: 'string', format: 'date-time' });
